<template>
  <b-overlay
    :show="loading"
    class="bg-white "
  >
    <div class="row">
      <div class="col-12 mt-3">
        ¿Estás seguro de que quieres facturar {{ receipts.length }} comprobantes?
      </div>
      <div
        class="col-12 mt-3"
      >
        <b-form id="invoice-form" data-vv-scope="invoice-form">
          <b-form-datepicker
            placeholder="Fecha de emisión"
            v-model="issueDate"
            label-help="Puede usar las flechas del teclado y espacio"
            v-validate="'required'"
            name="issueDate"
            data-vv-as="fecha de emisión"
            :state="errors.has('invoice-form.issueDate') ? false : null"
          />
          <b-form-invalid-feedback>
            {{ errors.first('invoice-form.issueDate') }}
          </b-form-invalid-feedback>
        </b-form>
      </div>
      <vs-divider></vs-divider>
      <b-col
        cols="12"
        class="text-right"
      >
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          v-on:click="onInvoice"
          data-cy="cancel-batch"
        >
          Si, Estoy seguro!
        </b-button>
      </b-col>
    </div>

  </b-overlay>
</template>
<script>

import MasivasMixin from '@/febos/global/_vue/mixins/MasivasMixin';
import { LLAMADA_MASIVA_ADUANA_FACTURAR_COMPROBANTE_BASE } from '@/febos/servicios/api/aduanas/constantes';
import { ALERT_POSITION } from '@/febos/global/utils/configurations';

export default {
  mixins: [MasivasMixin],
  data() {
    return {
      loading: false,
      issueDate: ''
    };
  },
  props: {
    receipts: {
      type: Array,
      required: true
    }
  },
  methods: {
    async onInvoice() {
      const payload = {
        ...LLAMADA_MASIVA_ADUANA_FACTURAR_COMPROBANTE_BASE,
        ...{
          comunes: {
            ...LLAMADA_MASIVA_ADUANA_FACTURAR_COMPROBANTE_BASE.comunes,
            accion: 'facturar',
            body: { fechaEmision: this.issueDate }
          },
          payload: this.receipts.map(
            (receipt) => ({
              comprobante_id: receipt.comprobanteId
            })
          )
        }
      };
      this.loading = true;
      try {
        await this.sendMasiveProcess(payload);
        this.issueDate = '';
        this.$vs.notify({
          title: 'Genial!',
          text: `Se ha solicitado la facturación de ${this.receipts.length} comprobantes,
          te enviaremos un correo con los detalles cuando esta termine.`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          position: ALERT_POSITION
        });
        this.$emit('invoice');
      } finally {
        this.loading = false;
      }
    }
  },
  created() {
    this.loading = false;
    this.issueDate = '';
  }
};
</script>
